import Coupon from './Models/Coupon'

Vue.prototype.$models.$coupon = new Vue(Coupon)

Vue.component('coupons-table', () => import(/* webpackChunkName: "coupons-table" */ '@modulesPages/FerreCoupon/Resources/assets/js/Tables/CouponsTable'))

Vue.component('coupons-form', () => import(/* webpackChunkName: "coupons-form" */ '@modulesPages/FerreCoupon/Resources/assets/js/Forms/Coupons/CouponsForm'))

app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\FerreCoupon\\Entities\\Coupon': 'Cupón',
    }   
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\FerreCoupon\\Entities\\Coupon': 'Coupons',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'coupons': 'Modules\\FerreCoupon\\Entities\\Coupon',
	}	
}